import { TravelPackage } from '../types/TravelPackage';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createPackage = async (formData: FormData): Promise<TravelPackage> => {
  const response = await fetch(`${API_BASE_URL}/api/packages`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Failed to create package: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

export const fetchPackages = async (): Promise<TravelPackage[]> => {
  const response = await fetch(`${API_BASE_URL}/api/packages`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch packages: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

export const updatePackage = async (id: string, formData: FormData): Promise<TravelPackage> => {
  const response = await fetch(`${API_BASE_URL}/api/packages/${id}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`Failed to update package: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};

export const deletePackage = async (id: string): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/packages/${id}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
  });

  if (!response.ok) {
    throw new Error(`Failed to delete package: ${response.statusText}`);
  }
};

export const fetchPackageById = async (id: string): Promise<TravelPackage> => {
  const response = await fetch(`${API_BASE_URL}/api/packages/${id}`, {
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch package: ${response.statusText}`);
  }

  const data = await response.json();
  return data;
};
